// Expense Type State

export default {
  expenseTypeList: [],
  expenseTypeInfo: {},
  fullExpenseTypesList: []
}
